import React from 'react';
import { motion } from 'framer-motion';
import { ICONS } from '../../data/programs';
import '../../styles/components/landing/ProblemSection.css';

const ProblemSection = ({ eyebrow, title, subtitle, items = [] }) => {
  return (
    <section className="ls-problem">
      <div className="container">
        <div className="ls-problem__header">
          {eyebrow && <span className="ls-problem__eyebrow">{eyebrow}</span>}
          <h2 className="ls-problem__title">{title}</h2>
          {subtitle && <p className="ls-problem__subtitle">{subtitle}</p>}
        </div>

        <div className="ls-problem__grid">
          {items.map((item, i) => {
            const Icon = ICONS[item.icon] || ICONS.Brain;
            return (
              <motion.div
                key={i}
                className="ls-problem__card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.45, delay: i * 0.08 }}
              >
                <div className="ls-problem__icon">
                  <Icon size={22} />
                </div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
